import { styled } from '@mui/material/styles';
import Popover, { PopoverProps, popoverClasses } from '@mui/material/Popover';
import { forwardRef } from 'react';

// Обёртываем Popover в forwardRef
const PopoverWithRef = forwardRef<HTMLDivElement, PopoverProps>(
  function PopoverWithRef(props, ref) {
    return <Popover {...props} ref={ref} />;
  }
);

// Теперь стилизуем уже этот компонент
export const StyledPopover = styled(PopoverWithRef)(() => ({
  [`& .${popoverClasses.paper}`]: {
    backgroundColor: 'var(--unique-white-10)',
    border: '1px solid var(--gray-40)',
    padding: '12px',
    marginTop: '10px',
    borderRadius: '10px',
  },
}));
